import { IBar, IScore } from "../../../../common/types";

const getLastBar = (score: IScore) => {
    const allBarsIndexes = [0, 1, 2, 3, 4, 5].filter(n => score["bars" + (n || "")] as IBar[]);
    const voiceBarLengths = allBarsIndexes.map(n => (score["bars" + (n || "")] as IBar[]).length);
    const totalBars = Math.max.apply(Math, voiceBarLengths);
    return totalBars - 1;
};

export default getLastBar;
